import { axios } from '@/lib/axios';
import { UserResponse } from '../types';

export type LoginCredentialsDTO = {
  email?:string;
  password?:string;
  otp?:string;
  code?: string;
  redirect_uri?: string;
  scope?: string;
  client_id?: string;
  timezone?: string;
  businessId?: number;
  token?: string;
  isAddCalender?: boolean;
  isLinkCalender?: boolean;
  type?: string;
  userData?: UserResponse
};

export const loginWithEmailAndPassword: any = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  if(data.otp)
  {
    return axios.post('/verify-otp', data);
  }
  return axios.post('/login', data);
};
